"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overflowingChipsCount = exports.isChipInArray = void 0;

/**
 * Return number of overflowing chips given a row threshold
 * @param {array} chips - An array of chips
 * @param {Integer} overflowRowLimit - Number of rows to show before counting
 * overflow
 */
var overflowingChipsCount = function overflowingChipsCount(chips, overflowRowLimit) {
  var overflowChips = 0;

  if (chips) {
    chips.forEach(function (chip) {
      if (chip.offsetTop > chip.offsetHeight * overflowRowLimit) overflowChips++;
    });
  }

  return overflowChips;
};
/**
 * Check if supplied chip object already exists in searchData prop
 * @param {Object} chip - A chip object {lead: 'foo', value: 'bar'}
 * @param {Array} existingArr - An array of chip objects
 */


exports.overflowingChipsCount = overflowingChipsCount;

var isChipInArray = function isChipInArray(chip, existingArr) {
  return existingArr === null || existingArr === void 0 ? void 0 : existingArr.some(function (searchDataItem) {
    return searchDataItem.lead === chip.lead && searchDataItem.value === chip.value;
  });
};

exports.isChipInArray = isChipInArray;